namespace TabAurous.OMS {
    export interface ReasonStatusForm {
        Type: ReasonStatusEditor;
        TypeId: Serenity.LookupEditor;
        TypeDescription: Serenity.StringEditor;
        Notification: Serenity.StringEditor;
        IsDefault: Serenity.BooleanEditor;
        UpdateECommerce: Serenity.BooleanEditor;
        NotifyCustomer: Serenity.BooleanEditor;
    }

    export class ReasonStatusForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ReasonStatus';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReasonStatusForm.init)  {
                ReasonStatusForm.init = true;

                var s = Serenity;
                var w0 = ReasonStatusEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ReasonStatusForm, [
                    'Type', w0,
                    'TypeId', w1,
                    'TypeDescription', w2,
                    'Notification', w2,
                    'IsDefault', w3,
                    'UpdateECommerce', w3,
                    'NotifyCustomer', w3
                ]);
            }
        }
    }
}
